module.exports = __webpack_public_path__ + "img/header_dsk@2x.37f1f9e.webp";